var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOilCan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M637.875 168.031C634.391 161.969 627.391 158.922 620.531 160.375L450.828 197.984L400.859 167.547C392.781 162.609 383.25 160 373.328 160H288V112H336C344.838 112 352 104.836 352 96V80C352 71.162 344.838 64 336 64H176C167.164 64 160 71.162 160 80V96C160 104.836 167.164 112 176 112H224V160H48C21.531 160 0 181.531 0 208V272.297C0 291.359 11.281 308.625 28.75 316.281L96 345.699V374.001C96 397.156 117.531 416 144 416H400.766C414.656 416 427.844 410.797 437.359 401.25L635.75 186.859C640.5 181.734 641.359 174.109 637.875 168.031ZM96 293.301L48 272.297V208H96V293.301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilCan);
export default __webpack_public_path__ + "static/media/oil-can.cb9227e4c0f6d76e60c08b2917f40691.svg";
export { ForwardRef as ReactComponent };